class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
(function () {
  let running = false;

  // If your theme dispatches a custom event, keep it.
  // If it doesn’t, DOMContentLoaded fallback helps initial load.
  document.addEventListener('cart-notification:open', handleLimit);
  document.addEventListener('DOMContentLoaded', handleLimit);

  function handleLimit() {
    if (running) return;
    running = true;

    const data = document.getElementById('weekly-limit-data');
    if (!data) { running = false; return; }

    const weeklyLimit = Number(data.dataset.weeklyLimit || 3);
    const weeklyCount = Number(data.dataset.weeklyCount || 0);

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const projected = weeklyCount + (cart.item_count || 0);

        // Always remove any previous banners first (prevents duplicates)
        removeExistingWarnings();

        if (projected > weeklyLimit) {
          injectWarning(projected, weeklyLimit, weeklyCount);
          disableCheckout();
        }
      })
      .finally(() => { running = false; });
  }

  function removeExistingWarnings() {
    document.querySelectorAll('.weekly-limit-warning').forEach(el => el.remove());
  }

  function injectWarning(projected, weeklyLimit, weeklyCount) {
    const popup =
      document.querySelector('.cart-notification') ||
      document.querySelector('.cart-popup') ||
      document.body;

    // Target the content area if it exists, otherwise use popup root
    const container =
      popup.querySelector('.cart-notification__content') ||
      popup.querySelector('.cart-popup__content') ||
      popup;

    const div = document.createElement('div');
    div.className = 'weekly-limit-warning';
    div.style.cssText = `
      border:1px solid #d72c0d;
      background:#fff4f4;
      color:#4a0b0b;
      padding:12px;
      margin:0 0 12px 0;
      border-radius:6px;
      font-size:14px;
    `;

    div.innerHTML = `
      <strong>Weekly limit reached.</strong><br>
      You may purchase up to ${weeklyLimit} items per week.<br>
      You already have ${weeklyCount} item(s) this week and your cart would total ${projected}.<br>
      Your limit resets on <strong>Thursday</strong>.
    `;

    // Put it at the top of the popup content (ONE location)
    container.insertBefore(div, container.firstChild);
  }

  function disableCheckout() {
    // Disable checkout links/buttons inside the popup only
    const popup =
      document.querySelector('.cart-notification') ||
      document.querySelector('.cart-popup') ||
      document;

    popup.querySelectorAll('a[href^="/checkout"], button[name="checkout"], button.checkout')
      .forEach(el => {
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.45';
        el.style.cursor = 'not-allowed';
      });
  }
})();